import React from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import PageLayout from '../../../shared/components/PageLayout';
import { useMe } from '../../../shared/hooks/useMe';

const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { me } = useMe();
  const tabs = [
    ...(me?.can_manage_roles ? [
      { label: 'Roles', path: '/admin/roles' },
    ] : []),
    ...(me?.can_manage_users ? [{ label: 'Users', path: '/admin/users' }] : []),
    ...(me?.can_manage_roles ? [
      { label: 'Permissions', path: '/admin/permissions' },
    ] : []),
  ];
  const idx = tabs.findIndex((tab) => location.pathname.startsWith(tab.path));
  const value = idx >= 0 ? idx : 0;

  return (
    <PageLayout>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Admin
      </Typography>
      <Tabs value={value} onChange={(_, v) => navigate(tabs[v].path)} sx={{ mb: 2 }}>
        {tabs.map((tab) => <Tab key={tab.path} label={tab.label} />)}
      </Tabs>
      <Box>{children}</Box>
    </PageLayout>
  );
};

export default AdminLayout;
